module.exports = __webpack_public_path__ + "img/trois.9f850a0d.png";